export function canSelectOrganisation(input: { superAdmin: boolean; organisationCount: number }) {
  return input.superAdmin && input.organisationCount > 1;
}

export function organisationRoleLabel(input: { superAdmin: boolean; supportContext?: boolean; tenantAdmin: boolean }) {
  if (input.superAdmin && input.supportContext) return 'Platform support context';
  return input.tenantAdmin ? 'Tenant administration' : 'Organisation member';
}

export function authenticatedDocumentTitle(firstName: string) {
  return `${firstName || 'WellDone'} | WellDone`;
}
